import "./adminHome.scss";

import CardHomeAdmin from "../../../components/card-home-admin/cardHomeAdmin";
import BarChartDisplay from "../../../components/chart-bar/chatbar";
import ListHomeAdmin from "../../../components/custom-list/custom-list";
import { MagnetIcon, UserSearchIcon } from "lucide-react";
import { useEffect } from "react";
import { fetchInvesting } from "../../../store/AssetsSlice";
import { useAppDispatch, useAppSelector } from "../../../features/helpers";
import { getLoggedOrganization, getLoggedUserType } from "../../../store/AuthSlice";
import SuperAdminHome from "./superAdminHome";

const Home = () => {

    const dispatch = useAppDispatch();

    const loggedUserType            = useAppSelector(getLoggedUserType);


    return (

        <div className="home-wrapper">
            
            { (loggedUserType?.toLowerCase() === 'super admin') &&
                <>
                    <h1 className="page-title">
                        Dashboard OTC TRKBit
                        <small>Visão geral da plataforma</small>
                    </h1>
                    <SuperAdminHome />
                </>
            }

        </div>

    )
}

export default Home;